/**
 * 
 * @file Open With button
 * @author Box
 */

import * as React from 'react';
import noop from 'lodash/noop';
import Button from 'box-react-ui/lib/components/button/Button';
import IconOpenWith from 'box-react-ui/lib/icons/general/IconOpenWith';
import { FormattedMessage } from 'react-intl';
import Tooltip from '../Tooltip';
import OpenWithButtonContents from './OpenWithButtonContents';
import ICON_FILE_MAP from './IconFileMap';
import { CLASS_INTEGRATION_ICON } from '../../constants';
import messages from '../messages';

/**
 * Gets the tooltip text for the ContentOpenWith button
 *
 * @private
 * @return {?(string | Element)} the tooltip message
 */
var getTooltip = function getTooltip(displayDescription, error, isLoading) {
    if (isLoading) {
        return null;
    }
    if (error) {
        return React.createElement(FormattedMessage, messages.errorOpenWithDescription);
    }
    if (displayDescription) {
        return displayDescription;
    }

    return React.createElement(FormattedMessage, messages.emptyOpenWithDescription);
};

var OpenWithButton = function OpenWithButton(_ref) {
    var error = _ref.error,
        onClick = _ref.onClick,
        displayIntegration = _ref.displayIntegration,
        isLoading = _ref.isLoading;

    var _ref2 = displayIntegration || {},
        id = _ref2.appIntegrationId,
        displayDescription = _ref2.displayDescription,
        displayName = _ref2.displayName,
        isDisplayIntegrationDisabled = _ref2.isDisabled;

    var isDisabled = !!isDisplayIntegrationDisabled || !displayName;
    var IntegrationIcon = displayName && ICON_FILE_MAP[displayName];
    var Icon = IntegrationIcon || IconOpenWith;

    return React.createElement(
        Tooltip,
        {
            text: getTooltip(displayDescription, error, isLoading),
            position: 'bottom-center'
        },
        React.createElement(
            Button,
            {
                isDisabled: isDisabled,
                onClick: onClick ? function () {
                    return onClick(id);
                } : noop
            },
            React.createElement(
                OpenWithButtonContents,
                null,
                React.createElement(Icon, {
                    className: CLASS_INTEGRATION_ICON,
                    height: 26,
                    width: 26
                })
            )
        )
    );
};

export default OpenWithButton;